import { base_url } from "services/routeScopeUtils";

export const FAQ_LIST = `${base_url()}/faq`
